import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class LabourService {
    constructor(private datatask: DataTaskService) {}

    public getLabourers(params?: GetLabourersParams): Promise<LabourerItem[]> {
        return this.datatask.Post(101, params);
    }
}

export interface LabourerItem {
    item_id: string;
    item_name: string;
    item_state: string;
    item_parms: string;
    orderby: string;
    item_filtervalue: string;
}

export interface GetLabourersParams {
    searchtext?: string;

    /**
     * @default 'ALL'
     */
    gb_labourtype?: 'ALL' | 'INTERNAL' | 'EXTERNAL';

    /**
     * @default 'ALL'
     */
    activestatus?: 'ALL' | 'NOT_ACT' | 'ACT';

    businessco_no?: string | number;
}
